import React, { useState } from 'react'
import NetaqInput from '../NetaqInput';
import { useTranslate } from '../TranslationText';

export default function UserDropDown({ onChange , profile, setProfile }) {
    const { translate } = useTranslate();
    const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
    const subOwnerProfilesByIdData = userProfile?.subAccounts ?? [];
    const subAccountId = localStorage.getItem("currentSubAccountId");

    

    


    const handelSelectedAccountChange = async (element) => {
        setProfile(element);
        onChange(element?.value);
    };
    const getSelectedAccountName = () => {
        const selectAccount = userProfile.subAccounts.filter(
            (x) => x.value == subAccountId
        );

        if (selectAccount.length > 0) {
            return selectAccount[0];
        }
        else {
            return false;
        }
    };
    return (
        <div>{userProfile?.accountType !== "Agent" ? (
            <>
                <NetaqInput
                    label={translate("web.selectedAccount", "Selected Account")}
                    name="selectAccount"
                    type="select"
                    listSelect={[
                        {
                            label:
                                userProfile?.ownerRegisterNo +
                                " - " +
                                userProfile[
                                `fullName${currentLanguage === "en" ? "" : "Ar"}`
                                ],
                            value: localStorage.getItem("EAHSUserID"),
                        },
                        ...(!!subOwnerProfilesByIdData &&
                            !!subOwnerProfilesByIdData.length > 0 &&
                            subOwnerProfilesByIdData.map((a) => ({
                                label:
                                    a.registerNo +
                                    " - " +
                                    a[`text${currentLanguage === "en" ? "" : "Ar"}`],
                                value: a.value,
                            }))),
                    ]}
                    value={profile}
                    onChange={(e) => {
                        handelSelectedAccountChange(e);
                    }}
                    placeholder={localStorage.getItem("EAHSUserFullName")}
                />
            </>
        ) : (
            <label className="capatalize_text">
                {getSelectedAccountName().registerNo +
                    " - " +
                    getSelectedAccountName()[
                    `text${currentLanguage === "en" ? "" : "Ar"}`
                    ]}
            </label>
        )}</div>
    )
}
